import React from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { WHY_CHOOSE } from "../data/content";

const WhyChooseUs = () => {
  return (
    <section id="why" className="relative py-24 sm:py-32 lg:py-40" data-testid="why-choose-section">
      <div className="pointer-events-none absolute inset-0 grid-bg radial-fade opacity-30" />
      <div className="relative mx-auto max-w-[1400px] px-6 sm:px-8 lg:px-12">
        <Reveal className="mb-16 max-w-3xl">
          <Eyebrow>02 — Why Choose Us</Eyebrow>
          <h2 className="mt-5 font-display text-3xl font-semibold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
            Engineered like the platforms enterprises trust.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {WHY_CHOOSE.map((item, i) => {
            const Icon = Icons[item.icon] || Icons.Sparkles;
            return (
              <Reveal key={item.title} delay={i * 0.06}>
                <motion.div
                  whileHover={{ y: -6 }}
                  transition={{ type: "spring", stiffness: 300, damping: 20 }}
                  className="group relative h-full overflow-hidden rounded-3xl border border-border glass p-8"
                  data-testid={`why-card-${i}`}
                >
                  <div className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full bg-teal/10 blur-2xl opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                  <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-navy text-white transition-colors duration-300 group-hover:bg-teal">
                    <Icon className="h-7 w-7" strokeWidth={1.75} />
                  </span>
                  <h3 className="mt-6 font-display text-xl font-semibold text-foreground">{item.title}</h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-muted-foreground">{item.desc}</p>
                  <span className="mt-6 block h-px w-full origin-left scale-x-0 bg-teal transition-transform duration-500 group-hover:scale-x-100" />
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
